module.exports = __webpack_public_path__ + "static/img/3.b82680e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/3.jpg
// module id = gzpw
// module chunks = 1